import { SupplementaryInsuranceTypes } from '../../../../core/states/offer/offer.state';
import { Action } from '@ngrx/store';
import {
  deselectAccidentDeathCapitalProduct,
  deselectAccidentDisabilityCapitalProduct,
  deselectAccidentMedicalExpensesSupplementProduct,
  deselectBasicProduct,
  deselectComplementaryProduct,
  deselectComplementaryVivaProduct,
  deselectDailyCashProduct,
  deselectDentalProduct,
  deselectEmergencyCareProduct,
  deselectHospitalCapitalProduct,
  deselectHospitalDailyCashProduct,
  deselectHospitalProduct,
  deselectHospitalVivaProduct,
  deselectLegalProtectionProduct,
  deselectOutpatientComfortProduct,
  deselectOutpatientProduct,
  deselectOutpatientVivaProduct,
  deselectSicknessDeathOrDisabilityCapitalProduct,
} from '../../../../core/states/offer/supplementary-insurance/actions';
import { deselectYouthPackage } from '../../../../core/states/offer/offer.actions';

export type TypedAction<T> = Action & { type: T };

interface PersonId {
  personId: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const deselectYouthProduct = (personId: PersonId) => {
  deselectHospitalProduct(personId);
  deselectComplementaryProduct(personId);
  deselectOutpatientProduct(personId);
  return deselectYouthPackage(personId);
};

export const supplementaryInsuranceDeselectActionMap: {
  [key in SupplementaryInsuranceTypes]-?: (personId: PersonId) => PersonId & TypedAction<string>;
} = {
  basic: deselectBasicProduct,
  youth: deselectYouthProduct,
  hospital: deselectHospitalProduct,
  hospitalViva: deselectHospitalVivaProduct,
  complementary: deselectComplementaryProduct,
  complementaryViva: deselectComplementaryVivaProduct,
  outpatient: deselectOutpatientProduct,
  outpatientComfort: deselectOutpatientComfortProduct,
  outpatientViva: deselectOutpatientVivaProduct,
  hospitalCapital: deselectHospitalCapitalProduct,
  accidentDeathCapital: deselectAccidentDeathCapitalProduct,
  accidentDisabilityCapital: deselectAccidentDisabilityCapitalProduct,
  sicknessDeathOrDisabilityCapital: deselectSicknessDeathOrDisabilityCapitalProduct,
  legalProtection: deselectLegalProtectionProduct,
  dental: deselectDentalProduct,
  hospitalDailyCash: deselectHospitalDailyCashProduct,
  dailyCash: deselectDailyCashProduct,
  emergencyCare: deselectEmergencyCareProduct,
  accidentMedicalExpensesSupplement: deselectAccidentMedicalExpensesSupplementProduct,
};
